import React from 'react';
import { Users, MapPin, Building, Award } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const TrustStats = () => {
  const { language } = useLanguage();

  const stats = [
    {
      icon: Users,
      value: '300+',
      label: language === 'en' ? 'Satisfied Clients' : 'Clientes Satisfeitos',
      description: language === 'en' ? 'Who trusted our service' : 'Que confiaram no nosso serviço'
    },
    {
      icon: MapPin,
      value: '6',
      label: language === 'en' ? 'Premium Regions' : 'Regiões Premium',
      description: language === 'en' ? 'Lisbon, Cascais, Comporta...' : 'Lisboa, Cascais, Comporta...'
    },
    {
      icon: Building,
      value: '100%',
      label: language === 'en' ? 'Market Access' : 'Acesso ao Mercado',
      description: language === 'en' ? 'All agencies in one' : 'Todas as agências numa só'
    },
    {
      icon: Award,
      value: '0€',
      label: language === 'en' ? 'Cost to Buyer' : 'Custo para o Comprador',
      description: language === 'en' ? 'Our service is free for you' : 'O nosso serviço é gratuito para si'
    }
  ];

  return (
    <section className="py-12 bg-white border-y border-slate-100">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-5xl mx-auto">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="flex justify-center mb-3">
                <div className="w-12 h-12 rounded-full bg-brand-soft flex items-center justify-center group-hover:bg-brand-primary/20 transition-colors">
                  <stat.icon className="w-6 h-6 text-brand-primary" />
                </div>
              </div>
              <div className="text-3xl md:text-4xl font-display font-light text-brand-primary mb-1">
                {stat.value}
              </div>
              <div className="text-sm md:text-base font-display font-medium text-slate-800 mb-1">
                {stat.label}
              </div>
              <p className="text-xs text-slate-500 font-serif hidden md:block">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustStats;
